/**
 * Some backend endpoints return a resource directly, while others wrap it in an
 * `{ data: T }` envelope. `unwrap` normalises both shapes to `T`.
 */
export type Enveloped<T> = T | { data: T };

export function unwrap<T>(response: Enveloped<T>): T {
  if (response && typeof response === 'object' && 'data' in response) {
    return (response as { data: T }).data;
  }
  return response as T;
}
